export const getPages = state => state.pages
export const getTotalPages = state => state.pages.length
export const getLastPagePosition = state => {
  const { pages } = state

  if( !pages.length ) return 

  const lastPosition = +pages[pages.length -1].page_position + 1
  
  return lastPosition
} 
export const getActualPage = state => {
  const { activePage } = state
  if( activePage && activePage.properties ) {
    if( typeof activePage.properties === 'string' ){
      activePage.properties = JSON.parse( activePage.properties )
    }
  }
  return activePage
}
export const getActualPageIndex = state => {
  const { activePage, pages } = state
  if( !activePage ) {
    return 0
  }

  return pages.findIndex( page => +page.id === +activePage.id )
}


// WEBPACK FOOTER //
// ./src/store/getters/pages.js